import { text } from '@storybook/addon-knobs';
import { storiesOf } from '@storybook/react';
import * as React from 'react';
import {
  RiskQuestionsComponent,
  TRiskQuestionsProps,
} from './riskQuestionComponent';

import { ERiskPageType } from '../models/riskPageType';
import { TQuestionData } from '../models/riskQuestion.model';

let height = 50;
let investmentAmount = 10000;

let questionData: TQuestionData = {
  heading: 'Your Age Range',
  questionId: 36,
  sequence: 1,
  question: "Client's risk tolerance for this portfolio",
  choices: [
    {
      choiceId: 1,
      sequence: 1,
      choice: 'Low',
      score: 0.33333298563957214,
      selected: true,
    },
    {
      choiceId: 2,
      sequence: 2,
      choice: 'Moderate',
      score: 0.6666659712791443,
      selected: false,
    },
    {
      choiceId: 3,
      sequence: 3,
      choice: 'High',
      score: 0.9999989867210388,
      selected: false,
    },
    {
      choiceId: 4,
      sequence: 4,
      choice: 'Very High',
      score: 1.3333319425582886,
      selected: false,
    },
    {
      choiceId: 5,
      sequence: 5,
      choice: 'Super High',
      score: 1.3333319425582886,
      selected: false,
    },
    {
      choiceId: 6,
      sequence: 6,
      choice: 'Highest',
      score: 1.3333319425582886,
      selected: false,
    },
  ],
  selectedChoiceId: 0,
};

storiesOf('Risk Question Template', module).add('default', () => {
  return (
    <RiskQuestionsComponent
      questionType={ERiskPageType.AgeRange}
      investmentAmount={2000}
      riskAnswer={1}
      backButtonText="BACK"
      backButtonClassName="button button-secondary button-lg"
      onBackButtonClick={() => {
        alert('back button clicked');
      }}
      nextButtonText="NEXT"
      onNextButtonClick={() => {
        alert('next button clicked');
      }}
      nextButtonClassName={'button button-primary button-lg ml-2'}
      onRadioChange={() => {
        alert('radio option changed');
      }}
      questionData={questionData}
    />
  );
});
